import {Component, OnInit, OnDestroy, ViewChild} from '@angular/core';
import {NotifierService} from 'angular-notifier';
import {Editors, Filters, Formatters} from 'angular-slickgrid';
import {RestApiService} from '../rest-api.service';
import {Router} from '@angular/router';
import {MessageService} from '../message.service';
import {CustomInputEditor} from '../custom-inputEditor';
import {NgbDateStruct, NgbModal, NgbModalRef} from '@ng-bootstrap/ng-bootstrap';
import {Subscription} from 'rxjs';
import {FormControl} from '@angular/forms';


@Component({
    selector: 'app-support-group-holidays',
    templateUrl: './support-group-holidays.component.html',
    styleUrls: ['./support-group-holidays.component.css']
})
export class SupportGroupHolidaysComponent implements OnInit, OnDestroy {
    displayed = true;
    clientId: number;

    add = false;
    del = false;
    edit = false;
    view = false;

    displayData: any;
    slideChecked = 'F';
    isError = false;
    errorMessage: string;
    respObject: any;
    totalData: number;
    // datesSelected: NgbDateStruct[] = [];
    private notifier: NotifierService;
    holidays: any;
    hourStart: any;
    isHidden = true;
    desc: any;
    nextOffset: number;
    previousOffset: number;
    collectionSize: number;
    pageSize: number;
    paginationType: string;
    page_no: number;
    totalPage: number;
    private userAuth: Subscription;
    private baseFlag: any;
    offset: number;
    dataLoaded: boolean;
    support_group = [];
    groupSelected = [];
    groupSelectedstr: string;
    isSupp: boolean;
    supportGroup = new FormControl();
    options: any;
    optionSelected: number;
    optionName: string;
    isSameasClient = true;
    assignedGroup: string;
    assignedGroupArray = [];
    showSearch = true;
    isLoading = false;
    searchData: FormControl = new FormControl();
    holidaySelected: any;
    holiday: any;
    strtTime: string;
    dataArr: any;
    showExportBtn = true;
    dataExcel = [];
    isExportDisable = false;
    sholidays: any;
    @ViewChild('scarch_content') private scarch_content;
    private searchModalReference: NgbModalRef;

    constructor(private _rest: RestApiService, private messageService: MessageService, private route: Router,
                private modalService: NgbModal, notifier: NotifierService) {
        // this.options = [{id: 1, name: 'Update Holiday with Support Group'}, {id: 2, name: 'Add new Holiday'}];
        this.notifier = notifier;
        this.messageService.getCellChangeData().subscribe(item => {
            // console.log(item);
            switch (item.type) {
                case 'change':
                    console.log('changed');
                    if (!this.messageService.edit) {
                        this.notifier.notify('error', 'You do not have edit permission');
                    } else {
                        console.log(JSON.stringify(item));
                        if (item.holidaytype === false) {
                            item.holidaytype = 'H';
                        } else {
                            item.holidaytype = 'F';
                        }
                        let matched = true;
                        if (item.holidaytype === 'H') {
                            const val = item.holidaystarttime.split(':');
                            // console.log(val.length);
                            if (val.length === 2) {
                                // console.log(val[0]);
                                if (Number(val[0]) > -1 && Number(val[0]) < 25) {
                                    // console.log(val[1]);
                                    if (Number(val[1]) > -1 && Number(val[1]) < 60) {
                                        if (Number(val[0]) === 0 && Number(val[1]) === 0) {
                                            matched = false;
                                        }
                                    } else {
                                        matched = false;
                                    }
                                } else {
                                    matched = false;
                                }
                            } else {
                                matched = false;
                            }
                        }
                        if (matched) {
                            item.user_id = this.messageService.getUserId();
                            item.clientid = this.clientId;
                            this._rest.updateHolidayDateVal(item).subscribe((res) => {
                                this.respObject = res;
                                if (this.respObject.success) {
                                    this.notifier.notify('success', 'Updated successfully');
                                } else {
                                    this.notifier.notify('error', this.respObject.errorMessage);
                                }
                            }, (err) => {
                                this.notifier.notify('error', this.messageService.SERVER_ERROR);
                            });
                        } else {
                            alert('Wrong Time format.Enter  time in 24 hr format ');
                        }
                    }
                    break;
                case 'delete':
                    // console.log('deleted');
                    if (!this.messageService.del) {
                        this.notifier.notify('error', 'You do not have delete permission');
                    } else {
                        if (confirm('Are you sure?')) {
                            console.log(JSON.stringify(item));
                            this._rest.deleteHolidayDateVal({
                                id: item.id,
                                user_id: this.messageService.getUserId(),
                                clientid: this.clientId
                            }).subscribe((res) => {
                                this.respObject = res;
                                if (this.respObject.success) {
                                    this.totalData = this.totalData - 1;
                                    this.messageService.setTotalData(this.totalData);
                                    this.messageService.sendAfterDelete(item.id);
                                } else {
                                    this.notifier.notify('error', this.respObject.errorMessage);
                                }
                            }, (err) => {
                                this.notifier.notify('error', this.messageService.SERVER_ERROR);
                            });
                        }
                    }
                    break;
            }
        });
    }


    ngOnInit() {
        this.optionSelected = 1;
        this.dataLoaded = false;
        this.nextOffset = 0;
        this.previousOffset = 0;
        this.pageSize = this.messageService.pageSize;
        this.page_no = 0;
        this.totalPage = 0;
        this.paginationType = 'next';
        this.isSupp = true;
        this.groupSelectedstr = '';
        this.displayData = {
            pageName: 'Maintain HolidayList',
            openModalButton: 'Add HolidayList',
            searchModalButton: 'Search',

            breadcrumb: 'HolidayList',
            folderName: 'All HolidayList',
            tabName: 'HolidayList',
            exportBtn: 'Export to excel'

        };
        const columnDefinitions = [
            {
                id: 'delete',
                field: 'id',
                excludeFromHeaderMenu: true,
                formatter: Formatters.deleteIcon,
                minWidth: 30,
                maxWidth: 30,
            },
            // {id: 'id', name: 'Id', field: 'id', sortable: true, filterable: true},
            {
                id: 'holiday_desc', name: 'Description', field: 'holiday_desc', sortable: true, filterable: true
            },
            {
                id: 'date', name: 'Date', field: 'holyday', sortable: true, filterable: true
            },
            {
                id: 'supportGrp', name: 'Support Group', field: 'supportGrp', sortable: true, minWidth: 300, filterable: true
            },
            {
                id: 'holidaytype', name: 'Full Holiday', field: 'holidaytype', sortable: true, filterable: true,
                formatter: Formatters.checkmark,
                filter: {
                    collection: [{value: '', label: 'All'}, {value: true, label: 'True'}, {value: false, label: 'False'}],
                    model: Filters.singleSelect,

                    filterOptions: {
                        autoDropWidth: true
                    },
                }, cssClass: 'highlight', editor: {model: Editors.checkbox}
            },
            {
                id: 'starttime',
                name: 'Start Time',
                field: 'holidaystarttime',
                sortable: true,
                filterable: true,
                cssClass: 'highlight',
                editor: {
                    model: CustomInputEditor,
                }
            }
        ];
        this.messageService.setColumnDefinitions(columnDefinitions);
        if (this.messageService.clientId) {
            this.clientId = this.messageService.clientId;
            this.baseFlag = this.messageService.baseFlag;
            this.onPageLoad();
        } else {
            this.userAuth = this.messageService.getClientUserAuth().subscribe(auth => {
                this.view = auth[0].viewFlag;
                this.add = auth[0].addFlag;
                this.edit = auth[0].editFlag;
                this.del = auth[0].deleteFlag;
                this.clientId = auth[0].clientId;
                this.baseFlag = auth[0].baseFlag;
                this.onPageLoad();
            });
        }

    }

    onPageLoad() {
        this.getTableData();
    }

    changeRouting(path: string) {
        this.messageService.changeRouting(path);
    }


    exportToExcel() {
        this.isExportDisable = true;

        // console.log("okkk" +this.clientId);
        this._rest.getAllSupportGroupHolidays(this.clientId).subscribe((res1) => {
            this.respObject = res1;
            if (this.respObject.success) {
                this.isExportDisable = false;

                this.dataExcel = this.respObject.details;
                // console.log('true' + JSON.stringify(this.dataExcel));
                this.messageService.exportAsExcelFile(this.dataExcel);
            } else {
                this.notifier.notify('error', this.respObject.errorMessage);
            }
        }, (err) => {
            this.notifier.notify('error', this.messageService.SERVER_ERROR);
        });
    }

    openModal(content) {
        this.optionSelected = 1;
        this.isSupp = true;
        this.isSameasClient = true;
        this.groupSelectedstr = '';
        this.holidays = '';
        // this.groupSelected = 0;
        if (!this.messageService.add) {
            this.notifier.notify('error', 'You do not have add permission');
        } else {
            this.desc = '';
            this.slideChecked = 'F';
            this.isHidden = true;
            this.groupSelected = [];
            this.modalService.open(content, {size: 'sm'}).result.then((result) => {
            }, (reason) => {

            });
            // this._rest.getSupportGroupAssignedWithHoliday(this.clientId).subscribe((res) => {
            //     this.respObject = res;
            //     if (this.respObject.success) {
            //         console.log(JSON.stringify(this.respObject)) ;
            //         this.assignedGroup = this.respObject.details[0].supportGroupLevelId ;
            //         this.assignedGroupArray = this.respObject.details[0].supportGroupLevelId.split(',');
            //         for ( let i = 0; i < this.assignedGroupArray.length; i++) {
            //             this.assignedGroupArray[i] = Number(this.assignedGroupArray[i]);
            //         }
            //         // this.groupSelected = this.assignedGroupArray ;
            //         console.log(this.assignedGroupArray);
            //     } else {
            //         this.isError = true;
            //         this.errorMessage = this.respObject.errorMessage;
            //     }
            // }, (err) => {
            //     this.isError = true;
            //     this.errorMessage = this.messageService.SERVER_ERROR;
            // });
            this._rest.getSubClient(this.clientId).subscribe((res) => {
                this.respObject = res;
                if (this.respObject.success) {
                    const sub_client = this.respObject.details[0].sub_client;
                    if (sub_client === 1) {
                        this.isSupp = false;
                        this._rest.getSupportGroupByClientId(this.clientId).subscribe((res1) => {
                            this.respObject = res1;
                            if (this.respObject.success) {
                                // this.respObject.details.unshift({id: 0, name: 'Select support group'});
                                this.support_group = this.respObject.details;
                                // let x = this.respObject.details;
                                // console.log(JSON.stringify(x));
                                this.groupSelected = this.assignedGroupArray;
                            } else {
                                this.isError = true;
                                this.errorMessage = this.respObject.errorMessage;
                            }
                        }, (err) => {
                            this.isError = true;
                            this.errorMessage = this.messageService.SERVER_ERROR;
                        });
                    }
                } else {
                    this.isError = true;
                    this.errorMessage = this.respObject.errorMessage;
                }
            }, (err) => {
                this.isError = true;
                this.errorMessage = this.messageService.SERVER_ERROR;
            });
        }
    }


    searchModal() {
        this.sholidays = '';
        this.searchModalReference = this.modalService.open(this.scarch_content);
        this.searchModalReference.result.then((result) => {
        }, (reason) => {
        });
    }


    search() {
        const holidayDate = this.messageService.ticketConverter(new Date(this.sholidays), 1);
        this._rest.searchAllSupportGroupHolidays(holidayDate, this.clientId,).subscribe((res1) => {
            this.respObject = res1;
            this.isLoading = false;
            if (this.respObject.success) {
                this.holiday = this.respObject.details;
                this.page_no = 1;
                this.messageService.setTotalData(this.holiday.length);
                this.messageService.setGridData(this.holiday);
                this.searchModalReference.close();
            } else {
                this.notifier.notify('error', this.respObject.errorMessage);
            }
        }, (err) => {
            this.isLoading = false;
            this.notifier.notify('error', this.messageService.SERVER_ERROR);
        });
    }

    // onOptionChange(selectedIndex: any){
    //     this.optionName = this.options[selectedIndex].name;
    //     this.optionSelected = this.options[selectedIndex].id;
    //     if (this.optionSelected !== 1) {
    //         this.isSameasClient = false;
    //     } else {
    //          this.isSameasClient = true;
    //     }
    // }

    save() {
        this.groupSelectedstr = this.groupSelected.toString();
        const data = {
            isSameAsClient: this.optionSelected,
            clientid: this.clientId,
            createdBy: this.messageService.getUserId()
        };
        // if (this.optionSelected !== 1) {
        data['holyday'] = this.holidays;
        data['holidaytype'] = this.slideChecked;
        data['holiday_desc'] = this.desc;
        // }
        // if (this.isSupp === false ) {
        //     data['group'] = this.groupSelectedstr;
        // }

        // console.log('=============' + JSON.stringify(data));
        if (!this.messageService.isBlankField(data)) {
            // if (this.isSupp === true) {
            data['group'] = this.groupSelectedstr;
            // }
            if (this.slideChecked === 'H') {
                data['holidaystarttime'] = this.timeFormat(this.hourStart);
            }
            // console.log('=================================> ' + JSON.stringify(data));
            this._rest.insertHoliday(data).subscribe((res) => {
                this.respObject = res;
                if (this.respObject.success) {
                    this.isError = false;
                    this.nextOffset = 0;
                    this.page_no = 0;
                    this.getTableData();
                    this.optionSelected = 1;
                    this.desc = '';
                    this.groupSelectedstr = '';
                    this.groupSelected = [];
                    this.notifier.notify('success', 'Inserted Successfully');
                } else {
                    this.isError = true;
                    this.errorMessage = this.respObject.errorMessage;
                }
            }, (err) => {
                this.isError = true;
                this.errorMessage = this.messageService.SERVER_ERROR;
            });
        } else {
            this.isError = true;
            this.errorMessage = this.messageService.BLANK_ERROR_MESSAGE;
        }
    }

    onButtonChange(selectedButton) {
        this.slideChecked = selectedButton.value;
        // console.log(this.slideChecked);
        if (this.slideChecked === 'H') {
            this.isHidden = false;
        } else {
            this.isHidden = true;
        }
    }

    getTableData() {
        this.getData({'offset': this.nextOffset, 'paginationType': ''});
    }

    isEmpty(obj) {
        for (const key in obj) {
            if (obj.hasOwnProperty(key)) {
                return false;
            }
        }
        return true;
    }

    getData(paginationObj) {
        const offset = paginationObj.offset;
        const paginationType = paginationObj.paginationType;
        this.dataLoaded = false;
        this._rest.getHolidayBySupGrp(this.clientId, offset, this.pageSize, paginationType).subscribe((res) => {
            this.respObject = res;
            this.executeResponse(this.respObject, offset, paginationType);
        }, (err) => {
            this.notifier.notify('error', this.messageService.SERVER_ERROR);
        });
    }

    executeResponse(respObject, offset, paginationType) {
        if (respObject.success) {
            this.dataLoaded = true;
            if (offset === 0) {
                this.totalData = respObject.details.totalData[0].count;
                this.totalPage = respObject.details.totalPage;
                if (this.totalPage === 0) {
                    this.totalPage = 1;
                }
            }
            if (!this.isEmpty(respObject.details.dataObj)) {
                const data = respObject.details.dataObj;
                this.nextOffset = respObject.details.nextOffset;
                this.offset = respObject.details.nextOffset;
                this.previousOffset = respObject.details.previousOffset;
                this.messageService.setTotalData(this.totalData);
                this.messageService.setGridData(data);
                // ----------------------------------------------
                if (offset !== 0) {
                    const totalCount = this.totalData;
                    const divRes = totalCount / this.pageSize;
                    const remainder = totalCount % this.pageSize;
                    if (remainder === 0) {
                        this.totalPage = parseInt(String(divRes), 10);
                    } else {
                        this.totalPage = parseInt(String(divRes), 10) + 1;
                    }
                }
                // ------------------------------------------------
                if (paginationType === 'next') {
                    this.page_no = this.page_no + 1;
                } else if (paginationType === 'prev') {
                    this.page_no = this.page_no - 1;
                } else if (paginationType === '' && this.page_no === 0) {
                    this.page_no = this.page_no + 1;
                }
                if (this.totalData <= this.pageSize * this.page_no) {
                    this.nextOffset = 0;
                }
            } else if (this.isEmpty(respObject.details.dataObj) && paginationType === 'next') {
                this.nextOffset = 0;
            } else if (this.isEmpty(respObject.details.dataObj) && paginationType === 'prev') {
                this.previousOffset = 0;
            } else if (paginationType === '' && this.page_no === 0) {
                this.page_no = this.page_no + 1;
            }
        } else {
            this.notifier.notify('error', respObject.errorMessage);
        }
    }

    onPageSizeChange(value: any) {
        this.page_no = 0;
        this.nextOffset = 0;
        this.pageSize = value;
        this.getData({'offset': this.nextOffset, 'paginationType': ''});
    }

    timeFormat(date) {
        // console.log(date);
        if (date !== undefined) {
            const d = new Date(date);
            const hour = d.getHours();
            const min = d.getMinutes();
            let nHour, nMin;
            if (hour < 10) {
                nHour = '0' + hour;
            } else {
                nHour = hour;
            }
            if (min < 10) {
                nMin = '0' + min;
            } else {
                nMin = min;
            }
            return nHour + ':' + nMin;
        } else {
            return '00:00';
        }
    }

    // change(value: NgbDateStruct[]) {
    //   this.datesSelected = value;
    //   this.holidays = value;
    //   console.log(JSON.stringify(value));
    // }
    ngOnDestroy(): void {
        if (this.userAuth) {
            this.userAuth.unsubscribe();
        }
    }
}
